module.exports = __webpack_public_path__ + "static/media/ICN_Region.36219212.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ICN_Region.svg
// module id = 166
// module chunks = 0